import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import background from "../assets/background.png";
import backgroundMobile from "../assets/background-mobile.png";

export const useStyles = makeStyles<Theme, { customBackgroundURL?: string }>(
  (theme) => ({
    root: {
      backgroundColor: "#fff8f1",
      backgroundImage: ({ customBackgroundURL }) =>
        `url(${customBackgroundURL ?? background})`,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      width: "100%",
      height: "100vh",
      display: "flex",
      flexDirection: "row",
      alignItems: "safe center",
      overflowY: "auto",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        justifyContent: "center",
        backgroundImage: ({ customBackgroundURL }) =>
          `url(${customBackgroundURL ?? backgroundMobile})`,
      },
    },
  }),
);
